import { sendAnalytics, queryShadowRoot } from './utils.js';
let acceptedElements = [];
const isHidden = ($elem) => $elem.hasAttribute('hidden') ||
    $elem.hasAttribute('focus-trap-hidden') ||
    ($elem.hasAttribute('aria-hidden') && $elem.getAttribute('aria-hidden') !== 'false') ||
    $elem.style.display === `none` ||
    $elem.style.opacity === `0` ||
    $elem.style.visibility === `hidden` ||
    $elem.style.visibility === `collapse`;
const isFocusable = ($elem) => acceptedElements.some((selector) => $elem.tagName === selector.toUpperCase());
export const pageviewImpressionCheck = (createImpression, optionalSelectors = [], optionalImpressionableComponents = [], customObj = {}) => {
    const allImpressionableComponents = [...document.querySelectorAll('[data-impression]'), ...optionalImpressionableComponents];
    const impressionSelectors = ['cipublic-link', 'cipublic-button', ...optionalSelectors];
    acceptedElements = impressionSelectors;
    Array.from(allImpressionableComponents).forEach((component) => {
        const globalProductString = [];
        setTimeout(() => {
            const allImpressionableLinks = queryShadowRoot(component, isHidden, isFocusable);
            Array.from(allImpressionableLinks).forEach((link) => {
                if (component !== null)
                    globalProductString.push(createImpression(link, '', component.tagName.toLowerCase()));
            });
            if (globalProductString.length) {
                globalProductString.join(',');
                let thisCustomObj = customObj;
                sendAnalytics('pageviewimpressions', globalProductString.join(','), '', thisCustomObj);
                thisCustomObj = {};
            }
        }, 3000);
    });
};
//# sourceMappingURL=pageview-impressions.js.map